import request from '@/utils/request'

// 查询社区小组话题列表
export function listCommunityGroupTopic(query) {
  return request({
    url: '/biz/admin/community/community/group/topic/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组话题分页
export function pageCommunityGroupTopic(query) {
  return request({
    url: '/biz/admin/community/community/group/topic/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组话题详细
export function getCommunityGroupTopic(data) {
  return request({
    url: '/biz/admin/community/community/group/topic/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组话题
export function addCommunityGroupTopic(data) {
  return request({
    url: '/biz/admin/community/community/group/topic/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组话题
export function updateCommunityGroupTopic(data) {
  return request({
    url: '/biz/admin/community/community/group/topic/edit',
    method: 'post',
    data: data
  })
}

// 删除社区小组话题
export function delCommunityGroupTopic(data) {
  return request({
    url: '/biz/admin/community/community/group/topic/delete',
    method: 'post',
    data: data
  })
}
